import React, { useContext, useEffect, useState } from 'react'
import { useUserTokens } from '@reservoir0x/reservoir-kit-ui'
import { PortfolioSortingOption } from 'components/common/PortfolioSortDropdown'
import { useAccount } from 'wagmi'
import { blockchainData } from 'constants/DragonsHolder'
import { ChainContext } from 'context/ChainContextProvider'
import LoadingCard from './common/LoadingCard'
import CountDown from './timers/CountDown'

interface TokensProps {
  selectedToken: number | undefined
  setTokenId: (tokenId: number|undefined) => void
  selectedToken2: number | undefined
  setTokenId2: (tokenId: number|undefined) => void
  setToken1Image:(uri:string|undefined)=>void
  setToken2Image:(uri:string|undefined)=>void
  token1Image:string | undefined
  token2Image:string |undefined
}

const DragonBreed = ({ setTokenId, selectedToken, setTokenId2, selectedToken2, setToken1Image, token1Image, setToken2Image, token2Image }: TokensProps) => {
  const [sortByType, setSortByType] =
    useState<PortfolioSortingOption>('acquiredAt')

  const [filterCollection, setFilterCollection] = useState<string | undefined>(
    undefined
  )
  const { address } = useAccount()
  const { chain } = useContext(ChainContext)

  let tokenQuery: Parameters<typeof useUserTokens>['1'] = {
    limit: 20,
    sortBy: sortByType,
    collection: filterCollection,
    includeTopBid: true,
    includeRawData: true,
    includeAttributes: true,
  }

  if (chain.name) {
    tokenQuery.contract = getCollectionAddress(chain.name)
  }

  const {
    data: tokens,
    fetchNextPage,
    mutate,
    isFetchingInitialData,
    isFetchingPage,
    isValidating,
  } = useUserTokens(address, tokenQuery, { revalidateIfStale: true })

  function getCollectionAddress(chainName: string): string {
    if (chainName.toLowerCase() == 'polygon mumbai') {
      chainName = 'mumbai'
    }
    if (chainName.toLowerCase() == 'binance smart chain testnet') {
      chainName = 'bsc-testnet'
    }
    const sepoliaData = blockchainData.find(
      (data) => data.chain === chainName.toLocaleLowerCase()
    )
    return sepoliaData?.collectionAddress!
  }
  function setDragon(uri: string | undefined, tokenID:number|undefined) {
    if (selectedToken == undefined) {
      //set Dragon1
      if (uri != token1Image) {
        setToken1Image(uri);
        setTokenId(tokenID);
      }
    } else {
      //set Dragon2
      if(selectedToken2 == undefined){
        setToken2Image(uri);
        setTokenId2(tokenID);
      }else{
        if (tokenID != selectedToken) {
            setToken2Image(uri);
            setTokenId2(tokenID);
        }
      }
    }
  }
  return (
    <div className="mb-8 flex flex-wrap w-100 gap-1 mx-5 justify-center mt-[50px] px-10">
      {isFetchingInitialData
        ? Array(10)
            .fill(null)
            .map((_, index) => <LoadingCard key={`loading-card-${index}`} />)
        : tokens?.map((token) => (
          <div key={`${token?.token?.contract}${token?.token?.tokenId}`} className="flex flex-col">
            <img
              className="m-2 cursor-pointer rounded-2xl h-[150px] xs:h-[120px]"
              src={token?.token?.image}
              onClick={() => setDragon(token?.token?.image,Number(token?.token?.tokenId))}
            />
            <p className="text-center">{`${token?.token?.name} #${token.token?.tokenId}`}</p>
            <CountDown time={1692124658}/>
          </div>
            /*<TokenCard
              token={{
                token: {
                  contract: token?.token?.contract || '',
                  tokenId: token?.token?.tokenId || '',
                  owner,
                  ...token?.token,
                },
                market: {
                  floorAsk: { ...token?.ownership?.floorAsk },
                  topBid: { ...token?.token?.topBid },
                },
              }}
              key={`${token?.token?.contract}${token?.token?.tokenId}`}
              mutate={mutate}
              collectionImage={token?.token?.collection?.imageUrl}
            />*/
          ))}
      {isFetchingPage ? (
        Array(10)
          .fill(null)
          .map((_, index) => {
            if (index === 0) {
              return <LoadingCard key={`loading-card-${index}`} />;
            }
            return <LoadingCard key={`loading-card-${index}`} />;
          })
      ) : (
        <div></div>
      )}
    </div>
  )
}

export default DragonBreed
